import { foreignPassportClearFormatting } from '.';

function foreignPassportFormat(input: string | undefined | null): string {
  const cleared = foreignPassportClearFormatting(input);

  let result = '';

  for (let i = 0; i < cleared.length; i++) {
    if (i === 2) {
      result += ' ';
    }

    result += cleared[i];
  }

  return result;
}

export default foreignPassportFormat;
